//
//
//
//
//
//

export default {
    components: {

    },
    name: 'StoreInfo',
}
